export default "__VITE_ASSET__xSWRdcyj__"